/*
 * @Description: 操作类的有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  条: 'items',
  取消: 'Cancel',
  确定: 'Confirm',
  保存: 'Save',
  删除: 'Delete',
  修改: 'Modify',
  转化: 'transform',
  分享: 'Share',
  更多: 'More',
  复制: 'Copy',
  下载: 'download',
  编辑: 'Edit',
  重置: 'Reset',
  作废: 'invalidate',
  关闭: 'Close',
  提交: 'Submit',
  导入: 'Import',
  收起: 'Collapse',
  状态: 'Status',
  展开: 'Expand',
  拨打: 'Dial',
  转移: 'transfer',
  查看: 'View',
  新增: 'Add',
  操作: 'Operation',
  已选择: 'selected',
  列设置: 'column setting',
  创建人: 'Creator',
  保存失败: 'Save failed',
  保存成功: 'Save successful',
  暂不确定: 'Uncertain',
  创建时间: 'Creation time',
  添加跟进: 'Add follow up',
  添加明细: 'Add detail',
  全屏展示: 'Full screen display',
  退出全屏: 'Exit full screen',
  模板导入: 'Template import',
  全部导出: 'Export all',
  批量转移: 'batch transfer',
  批量删除: 'batch delete',
  导出出错: 'Export error',
  操作失败: 'operation failed',
  刷新失败: 'refresh failed',
  查询失败: 'query failed',
  操作成功: 'operation successful',
  获取失败: 'fetch failed',
  编辑失败: 'edit failed',
  新增失败: 'add failed',
  温馨提示: 'warm tips',
  详细信息: 'detailed information',
  关联成功: 'association successful',
  展开更多: 'expand more',
  点击收起: 'click to collapse',
  最后更新人: 'Last updated by',
  最后更新时间: 'Last updated time',
  保存并关闭: 'Save and close',
  全选: 'select all',
  清空: 'Clear'
};
